import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { aiHubApi } from "../slices/AIHub.slice";
import authReducer from "../slices/Auth.slice";
import { buildWithCustomerAPI } from "../slices/BuildWithCustomer.slice";
import { cacheAdminAPI } from "../slices/CacheAdmin.slice";
import { commonAPI } from "../slices/Common.slice";
import { explorerCustomersAPI } from "../slices/ExploreCustomers.slice";
import { exploreProductsAPI } from "../slices/ExploreProducts.slice";
import { exploreFeatureRequestAPI } from "../slices/ExploreFeatureRequests.slice";
import { homeApi } from "../slices/Home.slice";
import { explorePartnersAPI } from "../slices/ExplorePartners.slice";
import { exploreReportsAPI } from "../slices/ExploreReports.slice";
import uiReducer from "../slices/UI.slice";
import { exploreHealthAPI } from "../slices/ExploreHealth.slice";
import { catalystAPI } from "../slices/Catalyst.slice";
import { closeTheLoopAPI } from "../slices/CloseTheLoop.slice";
import { baselineSecurityHealthAPI } from "../slices/BaselineSecurityHealth.slice";
import { purviewCVCAPI } from "../slices/PurviewCVC.slice";
import { cvcCustomerAPI } from "../slices/CVCCustomer.slice";
import { customerPerceptionAPI } from "../slices/CustomerPerception.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    common: commonAPI.reducer,
    [homeApi.reducerPath]: homeApi.reducer,
    [aiHubApi.reducerPath]: aiHubApi.reducer,
    [buildWithCustomerAPI.reducerPath]: buildWithCustomerAPI.reducer,
    [cacheAdminAPI.reducerPath]: cacheAdminAPI.reducer,
    [explorerCustomersAPI.reducerPath]: explorerCustomersAPI.reducer,
    [explorePartnersAPI.reducerPath]: explorePartnersAPI.reducer,
    [exploreProductsAPI.reducerPath]: exploreProductsAPI.reducer,
    [exploreReportsAPI.reducerPath]: exploreReportsAPI.reducer,
    [exploreFeatureRequestAPI.reducerPath]: exploreFeatureRequestAPI.reducer,
    [exploreHealthAPI.reducerPath]: exploreHealthAPI.reducer,
    [catalystAPI.reducerPath]: catalystAPI.reducer,
    [closeTheLoopAPI.reducerPath]: closeTheLoopAPI.reducer,
    [baselineSecurityHealthAPI.reducerPath]: baselineSecurityHealthAPI.reducer,
    [purviewCVCAPI.reducerPath]: purviewCVCAPI.reducer,
    [cvcCustomerAPI.reducerPath]: cvcCustomerAPI.reducer,
    [customerPerceptionAPI.reducerPath]: customerPerceptionAPI.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      commonAPI.middleware,
      homeApi.middleware,
      aiHubApi.middleware,
      buildWithCustomerAPI.middleware,
      cacheAdminAPI.middleware,
      explorerCustomersAPI.middleware,
      explorePartnersAPI.middleware,
      exploreProductsAPI.middleware,
      exploreReportsAPI.middleware,
      exploreFeatureRequestAPI.middleware,
      exploreHealthAPI.middleware,
      catalystAPI.middleware,
      closeTheLoopAPI.middleware,
      baselineSecurityHealthAPI.middleware,
      purviewCVCAPI.middleware,
      cvcCustomerAPI.middleware,
      customerPerceptionAPI.middleware
    ])
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
